/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import { styled } from 'fierry/react.old';


export const Path = styled.path`

  stroke: var(--svg-always-black);

  stroke-linecap: round;
  stroke-linejoin: round;
`;


export const getArrowLength = ({ geometry }) =>
{
  const hex = geometry.getHex();

  return hex.getExternalToInternalDistance() + hex.getUserBorderWidth() / 2;
}


export const getArrowWidth = (props) =>
{
  return getArrowLength(props) / 1.5;
}


export const getArrowEndPoint = (props) =>
{
  const { centerArrow, geometry, borderGeometry } = props;

  const length = getArrowLength(props);
  const border = geometry.getHex().getUserBorderWidth();

  const reverse = getArrowReverseOnIncomming(props);

  if (!borderGeometry.isExternal())
  {
    return (- length + border) / 2 * reverse;
  }

  if (centerArrow)
  {
    return - length / 2 * reverse;
  }

  return (- length - border / 4) * reverse;
}


export const getArrowReverseOnIncomming = ({ reverse }) =>
{
  return reverse ? - 1 : 1;
}

export const getArrowStroke = ({ geometry }) =>
{
  return geometry.getHex().getUserBorderWidth();
}


export const getLineStroke = ({ geometry }) =>
{
  return geometry.getHex().getSectorBorderWidth();
}


export const getLineStrokeDasharray = (props) =>
{
  const distance = getLineLength(props) / 12 - 0.001;

  return `0 ${distance};`
}


export const getLineLength = ({ borderGeometry, geometry }) =>
{
  return 2 * borderGeometry.getCenterToPartitionDistance(borderGeometry.getExternal());
}


export const shouldStartLonger = ({ borderGeometry }) =>
{
  const zone = borderGeometry.getLocation().getZone();

  return zone.getDirections().getIncomming().length > 0;
}


export const shouldEndLonger = ({ borderGeometry }) =>
{
  const neighbor = borderGeometry.getNeighbor().getLocation().getZone();

  return neighbor.getDirections().getOutgoing().length > 0;
}
